/**
 * Card component renders a styled container with customizable background, text, and additional classes.
 *
 * @param {string} bg - CSS classes for background styling.
 * @param {string} text - The text content to display inside the card.
 * @param {string} className - Additional CSS classes for custom styling.
 * @example
 * return (
 *   <Card bg="bg-blue-100" text="Hello World" className="text-center" />
 * )
 */

const BasicCard = ({ bg, text, className }) => {
  return (
    <div className={`${bg} ${className} text-center rounded-lg shadow-md`}>
      {text}
    </div>
  );
};

export default BasicCard;
